var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ErrorFilled } from '@one-thd/sui-icons';
import { TextField as MUITextField, InputAdornment, } from '@material-ui/core';
export var TextField = function (props) {
    var error = props.error, InputProps = props.InputProps;
    return (React.createElement(MUITextField, __assign({}, props, { InputProps: __assign({ endAdornment: error ? (React.createElement(InputAdornment, { position: "end" },
                React.createElement(ErrorFilled, { size: "small", style: { fill: '#E34A4A' } }))) : undefined }, InputProps) })));
};
